export type Product = {
  id: string
  storeName: string
  storeWebSite: string
  inquiryCode: string
  planProtectionType: string
  productTitle: string
  productImageUrl: string
  planTitle: string
  transactionDate: string
  shippingAddress: {
    address: string
    building: string
    city: string
    postalNumber: string
    prefecture: string
  }
  startedAt: string
  endedAt: string
  isFulfilled: boolean
  hasEmail: boolean
  hasPhone: boolean
}

export type EmailUpdateValue = {
  contractId: string
  email: string
}

export type PhoneUpdateValue = {
  contractId: string
  phone: string
}

export type CustomerData = {
  contractId: string
  customerId: string
}

export type AddressUpdateValue = {
  contractId: string
  shippingAddress: {
    postalNumber: string
    prefecture: string
    city: string
    address: string
    building: string
  }
}

// mi 系
export type GetContractsRequestValue = {
  page: number
  limit: number
}

export type ContractsResponse = {
  totalNumber: number
  contracts: Contract[]
}

export type ContractResponse = {
  contract: Contract
}

export type Contract = {
  id: string
  // inquiryCode: string
  // transactionId: string
  // transactionTotal: number
  transactionDate: string
  customer: Customer
  product: TransactionProduct
  plan: ContractPlan
  store: Store
  // isFulfilled: boolean
  status: contractStatus
  startedAt: string
  endedAt: string
  // createdAt: string
  // updatedAt: string
  // refundedAt: string
}

export type Customer = {
  // id: string
  // referenceId?: string
  name: string
  email: string
  phone?: string
  billingAddress?: Address
  shippingAddress?: Address
}

export type TransactionProduct = {
  // id: string
  // referenceId: string
  title: string
  // price: number
  imageUrl?: string
  // category?: string
  // sku?: string
  // brand?: string
  // isLive?: string
  // purchasePrice: number
}

export type ContractPlan = {
  // id: string
  title: string
  price: number
  termLength: number
  serviceType: serviceType
  protectionType: protectionType
  // url: string
  // coverageStartDays: number
}

export const ContractStatusMap = {
  Inactive: '保証期間前',
  Active: '期間内',
  Refunded: 'キャンセルされた注文',
  Expired: '保証期間終了',
} as const

export const ServiceTypeMap = {
  Repair: '修理',
  Replace: '交換',
  RepairAndReplace: '修理・交換',
} as const

export const ProtectionTypeMap = {
  Base: '自然故障',
  Adh: '物損故障',
  BaseAndAdh: '自然故障・物損故障',
} as const

type contractStatus = keyof typeof ContractStatusMap
type serviceType = keyof typeof ServiceTypeMap
type protectionType = keyof typeof ProtectionTypeMap

export type Store = {
  // id: string
  name: string
  webSite: string
  // logoUrl?: string
}

export type Address = {
  postalNumber: string
  prefecture: string
  city: string
  address: string
  building?: string
}

export const makePostalNumber = (data: Address | undefined) => {
  if (data) {
    return `〒${data.postalNumber}`
  }
  return '未登録'
}

export const makeAddress = (data: Address | undefined) => {
  if (data) {
    return `${data.prefecture}${data.city}${data.address} ${data.building || ''}`
  }
  return ''
}
